"use client";

import { useRouter } from "next/navigation";
import { useEffect } from "react";
import { useAuth } from "@/lib/auth-context";

export default function Home() {
  const { user, loading } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (loading) return;
    if (!user) {
      router.replace("/landing");
    } else {
      router.replace(user.onboarding_completed ? "/app" : "/onboarding");
    }
  }, [user, loading, router]);

  return null;
}
